module.exports = __webpack_public_path__ + "static/img/5-2-2.d06c44f1.jpg";